import { z } from 'zod';

import { FinancialAmountModel } from './financial-amount.model';

export const ChargeModel = z.object({
  amount: FinancialAmountModel,
  description: z.string(),
});
